export const GET_FEE_HISTORY = 'GET_FEE_HISTORY'
export const DOWNLOAD_VOUCHER = 'DOWNLOAD_VOUCHER'
export const GET_STUDENT_PROFILE_FEE_PARTICULARS = 'GET_STUDENT_PROFILE_FEE_PARTICULARS'
export const GET_CLASS_FEE_PACKAGE_DETAILS = 'GET_CLASS_FEE_PACKAGE_DETAILS'
